import Banner from '@/components/publicWebsite/home/banner'
import FunfactsArea from'@/components/publicWebsite/home/funfactArea'
import AboutArea from '@/components/publicWebsite/home/aboutArea'
import CoursesArea from '@/components/publicWebsite/home/courseArea'
import FeaturesArea from '@/components/publicWebsite/home/featuresArea'
import WhyChooseUs from '@/components/publicWebsite/home/whyChoose'
import TeamArea from '@/components/publicWebsite/home/team'
import Feedback from '@/components/publicWebsite/home/feedback'
import PricingArea from '@/components/publicWebsite/home/pricingArea'
import EventArea from '@/components/publicWebsite/home/eventArea'
import EnquiryForm from '@/components/publicWebsite/home/enquiryForm'


export default function Home() {
  return (
    <>
    
         <Banner />
        <FunfactsArea />
          <EnquiryForm />
        <AboutArea />
        <CoursesArea />
        <FeaturesArea />
        <WhyChooseUs />
        <TeamArea />
        <Feedback/>
        <PricingArea />
        <EventArea />
    </>
  )
}
